import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfigService } from '../../auth/services/app-config.service';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PoiProfileService {
  
  private backendUrl: string = `${this.appConfig.config.baseUrl}${this.appConfig.config.backendUrl}`;

  private handleError(error: HttpErrorResponse) {
    return throwError(() => error);
  }

  constructor( private http: HttpClient, private appConfig: AppConfigService) { }

  getPoi(id: number): Observable<any>  {
    return this.http.get<any[]>(
      `${this.backendUrl}/pois/${id}`,
      {observe: 'response'}
    ).pipe(
      catchError(this.handleError)
    );
  }

  deletePoi(id:number): Observable<any> {
    return this.http.put(
      `${this.backendUrl}/pois/${id}`,
      {observe: 'response'}
    ).pipe(
      catchError(this.handleError)
    );
  }

  massivePoiDelete(ids:number[]): Observable<any>{
    return this.http.put(
      `${this.backendUrl}/pois/multidelete`,ids,
      {observe: 'response'}
    ).pipe(
      catchError(this.handleError)
    );
  }

  removeAllPois(categoryId:number): Observable<any>{
    return this.http.put(
      `${this.backendUrl}/pois/removeAllPois/${categoryId}`,
      {observe: 'response'}
    ).pipe(
      catchError(this.handleError)
    );
  }
}
